import React from "react";
export  const  HtmlCodeInstructionNote = ()=>{
    return(
        <div>
            Instructions is coming soon...
        </div>
    )
}